import React, { useState } from 'react';
import styled from 'styled-components';
import {
  Anchor,
  Container,
  PageTitle,
  SpaceBetween,
} from '../../../utils/common';
import PropTypes from 'prop-types';
import { GoKebabVertical } from 'react-icons/go';
import Button from '../../../components/common/Button';
import { AiFillEdit } from 'react-icons/ai';
import { MdDelete } from 'react-icons/md';

const CardArea = styled.div`
  height: auto;
  width: 100%;
  border-radius: 4px;
  background-color: #ffffff;

`;
const CardHeader = styled.div`
  padding: 10px 20px 0;
  color: #1d2126;
  border-bottom: 1px solid #e5e5e5;
`;

const CardBody = styled.div`
  height: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TimeStamp = styled.div`
  color: #bdbdbd;
  font-size: 12px;
  display: flex;
`;

const Value = styled.p`
  font-size: 14px;
  color: #21334f;
  font-weight: 600;
`;

const Discussing = styled.div`
  display: flex;
  align-items: center;
`;

const Count = styled.div`
  font-size: 12px;
  color: #1d2126;
`;

const SecondaryButton = styled.button`
  width: 111px;
  height: 35px;
  font-size: 12px;
  color: #14a800;
  background-color: rgba(20, 168, 0, 0.05);
  border: none;
  border-radius: 6px;
`;

const Group = styled.div`
  overflow: hidden;
  margin-right: 6px;
  img {
    background: #c4c4c4;
    border: 2px solid #ffffff;
    width: 40px;
    height: 40px;
    display: inline-block;
    border-radius: 50%;
  }
  .stack-image {
    margin-left: -18px;
    postion: absolute;
  }
`;

const DropDown = styled.div`
  cursor: pointer;
  position: relative;
  display: inline-block;
  float: right;
`;

const Text = styled.p`
  margin-right: 10px;
  font-size: 14px;
`;

const RentalDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  margin-bottom: 1rem;
  padding-top: 1rem;
  padding-left: 1rem;
  width: 100%;
  height: 2rem;
  color: #21334f;
  background: rgba(0, 0, 0, 0.05);
`;

const DropdownMenuItem = styled.a`
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #000000;
  margin-bottom: 10px;
  &:hover {
    color: #000000;
  }
`;

const DropdownMenuItemLabel = styled.div`
  margin-left: 10px;
`;

export default function TrustGroupFinanceRecordCard({
  title,
  startDate,
  totalAmountLoaned,
  rentals,
  unpaidBalance,
  id,
  members,
}) {
  const [showOptions, setShowOptions] = useState(false);

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const DropdownArea = styled.div`
    display: ${showOptions ? 'block' : 'none'};
    position: absolute;
    background-color: #ffffff;
    min-width: 215px;
    box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
    z-index: 1;
    border-radius: 8px;
    padding: 13px 24px;
    right: 0;
  `;

  return (
    <CardArea>
      <CardHeader>
        <SpaceBetween>
          <PageTitle>{title}</PageTitle>
          <DropDown>
            <GoKebabVertical onClick={() => toggleOptions()} />
            <DropdownArea>
              <DropdownMenuItem href={`trust-group/${id}/edit`}>
                <AiFillEdit />
                <DropdownMenuItemLabel>Edit Trust Group</DropdownMenuItemLabel>
              </DropdownMenuItem>
              <DropdownMenuItem href={`trust-group/${id}/delete`}>
                <MdDelete />
                <DropdownMenuItemLabel>Delete</DropdownMenuItemLabel>
              </DropdownMenuItem>
            </DropdownArea>
          </DropDown>
        </SpaceBetween>
      </CardHeader>
      <CardBody>
        <RentalDetails>
          <Text style={{ paddingLeft: '0px' }}>RENTAL DETAILS</Text>
        </RentalDetails>
        <Container style={{ marginBottom: '0px' }}>
          <TimeStamp>
            <Text>Start Date</Text>
          </TimeStamp>
          <Value>{startDate}</Value>
        </Container>
        <Container style={{ marginBottom: '0px' }}>
          <TimeStamp>
            <Text>Total amount loaned</Text>
          </TimeStamp>
          <Value>{totalAmountLoaned}</Value>
        </Container>
        <Container style={{ marginBottom: '0px' }}>
          <TimeStamp>
            <Text>Rentals</Text>
          </TimeStamp>
          <Value>{rentals}</Value>
        </Container>
        <Container style={{ marginBottom: '0px' }}>
          <TimeStamp>
            <Text>Unpaid balance</Text>
          </TimeStamp>
          <Value>{unpaidBalance}</Value>
        </Container>
        <div>
          <SpaceBetween>
            <Discussing>
              <Group>
                {members.map((member, index) => (
                  <img
                    src={member}
                    alt={member}
                    key={index}
                    className={`${index !== 0 ? 'stack-image' : ''}`}
                  />
                ))}
              </Group>
              <Count>{`${members.length} member${
                members.length > 1 ? 's' : ''
              }`}</Count>
            </Discussing>
            <Anchor href={`finance-record/${id}`}>
              <SecondaryButton>View all Members</SecondaryButton>
            </Anchor>
          </SpaceBetween>
        </div>
      </CardBody>
    </CardArea>
  );
}

TrustGroupFinanceRecordCard.propTypes = {
  title: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  totalAmountLoaned: PropTypes.string.isRequired,
  rentals: PropTypes.string.isRequired,
  unpaidBalance: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  members: PropTypes.array.isRequired,
};
